import React from 'react';
import carousel from '../img/carousel-1.jpg'
import carouse2 from '../img/carousel-2.jpg'
import { GOOGLE_FORM_URL } from './AppConstant';


const Carousel = () => {
  return (
    <div className="container-fluid px-0">
      <div id="carouselId" className="carousel slide" data-bs-ride="carousel">
        {/* <ol className="carousel-indicators">
          <li
            data-bs-target="#carouselId"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="First slide"
          ></li>
          <li
            data-bs-target="#carouselId"
            data-bs-slide-to="1"
            aria-label="Second slide"
          ></li>
        </ol> */}

        <div className="carousel-inner" role="listbox">
          <div className="carousel-item active">
            <img src={carousel} className="img-fluid" alt="First slide" />
            <div className="carousel-caption">
              <div className="container carousel-content">
                <h6 className="text-secondary h4 animated fadeInUp">Empowering Technology & Learning</h6>
                <h1 className="text-white display-1 mb-4 animated fadeInRight">
                  Innovative IT Solutions & Training Experts
                </h1>
                <p className="mb-4 text-white fs-5 animated fadeInDown">
                  We specialize in delivering cutting-edge IT solutions and industry-relevant training programs. From
                  custom software development to upskilling courses in AI, Cloud, and Cybersecurity — we bridge the gap
                  between technology and talent.
                </p>
                {/* <a href={GOOGLE_FORM_URL} className="me-2">
                  <button
                    type="button"
                    className="px-4 py-sm-3 px-sm-5 btn btn-primary rounded-pill carousel-content-btn1 animated fadeInLeft"
                  >
                    Apply
                  </button>
                </a> */}
                <a href="/contact" className="ms-2">
                  <button
                    type="button"
                    className="px-4 py-sm-3 px-sm-5 btn btn-primary rounded-pill carousel-content-btn2 animated fadeInRight"
                  >
                    Contact Us
                  </button>
                </a>
              </div>
            </div>
          </div>

          <div className="carousel-item">
            <img src={carouse2} className="img-fluid" alt="Second slide" />
            <div className="carousel-caption">
              <div className="container carousel-content">
                <h6 className="text-secondary h4 animated fadeInUp">Best IT Solutions</h6>
                <h1 className="text-white display-1 mb-4 animated fadeInLeft">
                  Quality Digital Services You Really Need!
                </h1>
                <p className="mb-4 text-white fs-5 animated fadeInDown">
                  We provide tailored digital solutions that drive growth and innovation. From software development to
                  IT consulting and educational programs, our services are designed to empower businesses and individuals in an increasingly digital world.
                </p>
                <a href={GOOGLE_FORM_URL} className="me-2">
                  <button
                    type="button"
                    className="px-4 py-sm-3 px-sm-5 btn btn-primary rounded-pill carousel-content-btn1 animated fadeInLeft"
                  >
                    Apply
                  </button>
                </a>
                <a href="/contact" className="ms-2">
                  <button
                    type="button"
                    className="px-4 py-sm-3 px-sm-5 btn btn-primary rounded-pill carousel-content-btn2 animated fadeInRight"
                  >
                    Contact Us
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>

        <button className="carousel-control-prev" type="button" data-bs-target="#carouselId" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselId" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default Carousel;
